<p-dialog header="Instalar WINGS" [(visible)]="showPrompt" [modal]="true" [style]="{width: '20vw'}" [baseZIndex]="10000"
		  [draggable]="false" [resizable]="false" [closable]="false">
	<p>¿Desea instalar WINGS en su móvil?</p>
	<em class="pi pi-download icon"></em>
	<ng-template pTemplate="footer">
		<button type="button" pButton label="Si" (click)="installWings()"></button>
		<button type="button" pButton label="No" class="ui-button-secondary" (click)="showPrompt = false"></button>
	</ng-template>
</p-dialog>
